// test358
(358 && 0);
